import { client } from "../client";
import { DeleteCartItemParams } from "../../types";

export const deleteCartItem = async (params: DeleteCartItemParams): Promise<any> => {
  const response = await client.post("/deleteCartItem", params);

  return response.data;
};
